import React, { useEffect, useState } from "react";

const MasterReport = () => {
  const [report, setReport] = useState([]);

  useEffect(() => {
    fetch("https://merch.tjdstore.in/api/Backend/master_report.php")
      .then(res => res.json())
      .then(data => setReport(data));
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Master Invoice Report</h2>

      <table border="1" cellPadding="8" style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th>Invoice ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Mobile</th>
            <th>Product ID</th>
            <th>Product Name</th>
            <th>Qty</th>
            <th>Price</th>
            <th>Subtotal</th>
            <th>CGST</th>
            <th>SGST</th>
            <th>Total</th>
          </tr>
        </thead>

        <tbody>
          {report.map((row, index) => (
            <tr key={index}>
              <td>{row.invoice_id}</td>
              <td>{row.name}</td>
              <td>{row.email}</td>
              <td>{row.mobile}</td>
              <td>{row.product_id}</td>
              <td>{row.product_name}</td>
              <td>{row.qty}</td>
              <td>{row.price}</td>
              <td>{row.subtotal}</td>
              <td>{row.cgst}</td>
              <td>{row.sgst}</td>
              <td>{row.total}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MasterReport;
